import './styles.scss'

import React from 'react'
import PropTypes from 'prop-types'

export default function LoadingPlaceholder ({ style }) {
  return <div className='loading-placeholder' style={style} />
}

LoadingPlaceholder.propTypes = {
  style: PropTypes.object
}
